import React, { useState } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import styles from "./SwitchGroup.scss";

/**
 * SwitchGroup options , it will show the grouped button
 * Based on https://react-select.com/home.
 */
const propTypes = {
  /**
   * Options containing value and label.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  /**
   * Callback for when the option gets onClick
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Default value for the initial selected index
   */
  initialValue: PropTypes.string,
  /**
   * disabled for the grouped buttons
   */
  disabled: PropTypes.bool,
  /**
   * width for the grouped buttons
   */
  width: PropTypes.number,
  /**
   * title text
   */
  title: PropTypes.string,
  /**
   * subTitle text
   */
  subTitle: PropTypes.string,

  /**
   * Boolean filed which set equal space between the button or not
   */
  isSpaceBetween: PropTypes.bool,
};

const defaultProps = {
  options: [],
  initialValue: "",
  width: 300,
  title: "",
  subTitle: "",
  isSpaceBetween: false,
  disabled: false,
};

function SwitchGroup(props) {
  const {
    options,
    initialValue,
    width,
    isSpaceBetween,
    title,
    subTitle,
    disabled,
    onClick,
  } = props;

  const [value, setValue] = useState(initialValue);

  return (
    <Row>
      <Col className="my-auto">
        <div className={styles.title}>{title}</div>
        <div className={styles.subTitle}>{subTitle}</div>
      </Col>
      <Col style={{ display: "contents" }}>
        <div
          className={[
            `${styles.segemntGroup} ${
              isSpaceBetween ? styles.spacebetween : ""
            }`,
          ]}
          style={{ width }}
        >
          {options.map((item) => (
            <button
              type="button"
              key={item.value}
              disabled={disabled}
              className={item.value === value ? styles.segmentActive : ""}
              onClick={() => {
                if (!disabled) {
                  setValue(item.value);
                  onClick(item.value);
                }
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </Col>
    </Row>
  );
}

SwitchGroup.propTypes = propTypes;
SwitchGroup.defaultProps = defaultProps;

export default SwitchGroup;
